import React from 'react';
import { motion } from 'framer-motion';
import { SectionHeading } from './SectionHeading';
const ABOUT_IMG = 'https://cdn.magicpatterns.com/patterns/generated-images/53f6235a-48da-452c-8e12-c660b39c3ff7.jpg';
export function About() {
  return <section id="about" className="w-full bg-ivory py-24 md:py-32" data-id="element-11" data-mp="2trr4whe375rl">
      <div className="max-w-7xl mx-auto px-6 grid lg:grid-cols-2 gap-16 items-center" data-id="element-12" data-mp="2yt84m9ku4m6l">
        <motion.div initial={{
        opacity: 0,
        scale: 0.96
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} viewport={{
        once: true,
        margin: '-80px'
      }} transition={{
        duration: 0.7,
        ease: [0.22, 1, 0.36, 1]
      }} className="relative" data-id="element-13" data-mp="33s1fdu8qlz32">
          <div className="relative overflow-hidden rounded-2xl" data-id="element-14" data-mp="3hienpxpjjfsx">
            <img src={ABOUT_IMG} alt="African business professionals collaborating on strategy" className="w-full h-[520px] object-cover" data-id="element-15" data-mp="3hkr1rzs6h60p" />
          </div>
          <div className="absolute -bottom-6 -right-6 hidden md:block bg-navy text-ivory rounded-xl p-6 max-w-[220px] shadow-xl" data-id="element-16" data-mp="3rehn4vt0d0c6">
            <p className="font-serif text-3xl text-gold" data-id="element-17" data-mp="2grmh7pfhbln2">4</p>
            <p className="text-sm text-ivory/70 mt-1" data-id="element-18" data-mp="2gu8m1hazjn1l">
              disciplines, one outcome — sustainable growth
            </p>
          </div>
        </motion.div>

        <div data-id="element-19" data-mp="27sr927svk1h4">
          <SectionHeading eyebrow="About Flicker Africa" title="Growth Starts With the Right Partner." data-id="element-20" data-mp="27tait18dfjk2" />
          <div className="mt-6 space-y-5 text-graphite/85 text-lg leading-relaxed" data-id="element-21" data-mp="30gdelllnxg6m">
            <p data-id="element-22" data-mp="30ihii3jkaf6w">
              Africa is one of the world's fastest-growing markets — but success
              requires more than visibility. It requires insight, strategy,
              partnerships, and disciplined execution.
            </p>
            <p data-id="element-23" data-mp="3o6r7fec2nj29">
              At Flicker Africa, we work with organizations ready to grow beyond
              borders, strengthen their reputation, and create meaningful impact.
              Whether launching into a new market, building a stronger brand, or
              scaling customer acquisition, we provide the expertise to move
              businesses forward.
            </p>
            <p className="text-navy font-medium" data-id="element-24" data-mp="3tjpn3lvcr3m5">
              We don't simply execute campaigns — we build momentum, create
              influence, and accelerate sustainable growth across Africa.
            </p>
          </div>
        </div>
      </div>
    </section>;
}